"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShouldRenderNotificationMenu = void 0;
var _auth = require("@ori/auth");
var _featureToggles = require("@ori/feature-toggles");
var _constants = require("../constants");
const useShouldRenderNotificationMenu = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  return !isAnonymousUser && isFeatureEnabled(_constants.TopAreaFeature.DisplayNotificationIcon);
};
exports.useShouldRenderNotificationMenu = useShouldRenderNotificationMenu;
